import * as R from "ramda";
import * as React from "react";
import { FaGlobe } from "react-icons/fa";
import styled from "styled-components";
import { IOrganization } from "../../../reducers/course-author/types";
import colors from "../../../styles/colors";
import { localeCompare } from "../../../utils";

const List = styled.ul`
  display: block;
  padding: 0 0 0 2rem;
`;

const Label = styled.li`
  display: block;
  padding: 0.3rem;
  cursor: pointer;
  color: ${({ selected }: { selected: boolean }) => (selected ? colors.blue : colors.darkblue)};
`;

const Children = styled.li`
  display: block;
  padding: 0.3rem;
`;

const ReleaseLine = styled.span`
  padding: 0.3rem;
  margin-left: 1rem;
  border-radius: 0.2rem;
  background: ${colors.lightgrey};
  color: ${colors.teal};
`;

const byDisplayName = R.comparator<IOrganization>((a, b) => localeCompare(a.displayName, b.displayName));

export interface IOrganizationProps {
  selectedOrganization: IOrganization | null;
  organization: IOrganization;
  childrenLookup: { [k: string]: IOrganization[] };
  onClick: (org: IOrganization) => void;
}

export const Organization: React.SFC<IOrganizationProps> = ({
  selectedOrganization,
  organization,
  childrenLookup,
  onClick,
}) => {
  const onLabelClick = () => onClick(organization);
  const isSelected: boolean = organization.organizationId === selectedOrganization?.organizationId;

  return (
    <List>
      <Label onClick={onLabelClick} selected={isSelected}>
        <span>
          <FaGlobe /> {organization.displayName}
        </span>
        <ReleaseLine>{organization.releaseLine}</ReleaseLine>
      </Label>
      <Children>
        {childrenLookup[organization.organizationId]?.sort(byDisplayName).map((org: IOrganization) => (
          <Organization
            selectedOrganization={selectedOrganization}
            key={org.organizationId}
            organization={org}
            childrenLookup={childrenLookup}
            onClick={onClick}
          />
        ))}
      </Children>
    </List>
  );
};
